import { CompactDefaultNoCodeAppRenderer } from 'components/apps/compact/noCodeApp/defaultNoCodeAppRenderer/CompactDefaultNoCodeAppRenderer'
import { NoCodeAppMiroBoard, RenderableNoCodeApp } from 'types/apps/noCodeApps'

interface Props {
  app: Exclude<RenderableNoCodeApp, NoCodeAppMiroBoard>
}

export const CompactNoCodeApp = ({ app }: Props) => <CompactDefaultNoCodeAppRenderer app={app} />
